
import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
interface NavItem {
  label: string;
  path: string;
}

interface FooterNavColumnProps {
  title: string;
  items: NavItem[];
}

const FooterNavColumn: React.FC<FooterNavColumnProps> = ({ title, items }) => {
  return (
    <div className="min-w-0">
      <h4 className="font-heading text-base sm:text-lg mb-3 sm:mb-4 text-sage-50">{title}</h4>
      <ul className="space-y-2 sm:space-y-3">
        {items.map((item, index) => (
          <li key={index}>
            <Link 
              to={item.path} 
              className="text-sage-300 hover:text-sage-50 transition-colors duration-300 inline-flex items-center group text-xs sm:text-sm lg:text-base"
            >
              <ChevronRight className="h-3 w-3 sm:h-3.5 sm:w-3.5 -ml-1 opacity-70 group-hover:text-primary flex-shrink-0" />
              <span className="group-hover:underline break-words">{item.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterNavColumn;
